type Data = Record<string, any>;
export const PORTFOLIO_SNAPSHOT_TITLE = '持股账';
const object = (value: unknown): Data | null => value != null && typeof value === 'object' && !Array.isArray(value) ? value as Data : null;
const uint = (value: unknown): number | null => typeof value === 'number' && Number.isSafeInteger(value) && value >= 0 && value <= 0xffffffff ? value : null;
const text = (value: unknown) => typeof value === 'string' && value.trim() !== '' ? value : '未记录';
const finite = (value: unknown): value is number => typeof value === 'number' && Number.isFinite(value);
const money = (value: unknown) => finite(value) ? `${value.toFixed(2)} 元` : '未知';
const date = (value: unknown, asOf?: unknown) => {
  const day = uint(value), queryDay = uint(asOf);
  if (day == null) return '未记录';
  if (queryDay != null && day > queryDay) return '未记录';
  return `第 ${Math.floor(day / 360) + 1} 年 ${Math.floor(day % 360 / 30) + 1} 月 ${day % 30 + 1} 日（游戏日 ${day}）`;
};

/** 持股账一段的开头:资料日、条数。 */
export function portfolioScopeText(value: unknown, asOf: unknown): string[] {
  const lines = [PORTFOLIO_SNAPSHOT_TITLE, `资料日：${date(asOf)}`,
    '累计返回款含卖股回款和非分红分派；账面盈亏含没卖出去的估值，不是到手的钱。'];
  if (!Array.isArray(value)) lines.push('未记录');
  else if (!value.length) lines.push('没有登记持股');
  else lines.push(`共 ${value.length} 条`);
  return lines;
}

/** 一条持股账。 */
export function portfolioEntryText(value: unknown, index: number, asOf: unknown): string[] {
  const row = object(value);
  if (!row) return ['', `第 ${index + 1} 项：条目格式无效，见附录`];
  const firm = object(row.firm), id = uint(firm?.id);
  const subject = firm?.kind === 'firm'
    ? `${text(firm.name)} · ${id == null ? '公司编号未记录' : `公司 #${id}`}`
    : `${text(firm?.name)} · ${id == null ? '编号未记录' : `编号 #${id}`} · 实体类型 ${text(firm?.kind)}`;
  const quantity = finite(row.shares) && row.shares >= 0 ? `${row.shares} 股` : '未知';
  const proportion = finite(row.pct) && row.pct >= 0 ? `${row.pct}%` : '未知';
  const closed = row.closed === true ? '已关门' : row.closed === false ? '没关' : '未记录';
  const status = row.status === '' ? '未标注' : text(row.status);
  return ['', `第 ${index + 1} 项：${subject}`,
    `行业：${text(row.line)} · 状态：${status} · 关门：${closed}`,
    `登记股数：${quantity} · 持股比例：${proportion}`,
    `累计投入：${money(row.cost)} · 当前登记估值：${money(row.value)}`,
    `累计分红：${money(row.divs)} · 累计返回款：${money(row.back)}`,
    `账面盈亏：${money(row.gain)}`,
    `登记起始日：${date(row.since, asOf)}`];
}
